<template>
  <div class="text-black">
    <div class="no-data-container" v-if="cartTotal === 0 && OrderType == 'qr'">
      <div class="text-center p-4">
        <img src="/img/cart_empty.png" class="img-fluid " width="40%" alt="" />
        <h4 class="mt-4 font-weight-bold text-dark">{{ $t('noSelectedProduct') }}</h4>
        <span class="text-description">{{ $t('noSelectedProductDespt') }}</span><br>
        <router-link to="/dine-in/menulists">
          <CButton style="width: 200px;" class="btn-color-theme mt-3 ">
            <strong class="h5"> {{ $t('backToMenu') }} </strong>
          </CButton>
        </router-link>
      </div>
    </div>
    <div class="" v-else-if="cartTotal === 0 && OrderType == 'delivery'">
      <div class="text-center p-4">
        <img src="/img/cart_empty.png" class="img-fluid " width="40%" alt="" />
        <h4 class="mt-4 font-weight-bold text-dark">{{ $t('noSelectedProduct') }}</h4>
        <span class="text-description">{{ $t('noSelectedProductDespt') }}</span><br>
      </div>
    </div>

    <div v-else class=" text-left">
      <ul class="list-group list-group-flush mt-3" style="">
        <li class="list-group-item pr-0 pl-0" v-for="(list, index) in cartLists" :key="index">
          <table style="width: 100%" aria-describedby="">
            <tr>
              <td v-if="OrderType == 'delivery'" valign="middle" align="center">
                <div class="m-3"><input @click="setSelect(list)"
                    style="transform: scale(1.4);accent-color: var(--bg-color-theme)" type="checkbox"
                    :checked="list.isSelected"></div>
              </td>
              <td valign="top" align="left">
                <div v-if="list.remoteImagePath === null ||
                  list.remoteImagePath === undefined"
                  :style="{ 'background-color': getImgColor(list.indexColor || 0), 'border-radius': '5px', }"
                  :class="imageSize"></div>
                <div v-else :style="{
                  'background-image': `url('${noImg}')`,
                  'background-size': 'cover',
                  'background-position': 'center center',
                  'border-radius': '5px',
                }" :class="imageSize"><img class="image-inbox"
                    :src="getImageURL(list.remoteImagePath, '100')" @error="setErrorImg($event, list.remoteImagePath)">
                </div>
              </td>
              <td class="pl-2" style="font-size:medium;" valign="top">
                <div class="d-flex justify-content-between">
                  <div>
                    {{ getCartPLUName(list) }}
                    <br />
                    {{ list.productPLU?.SKURatio || '' }} {{ list.productPLU?.unit?.name || '' }}<br>
                    <!-- <div v-if="list.orderedOptions !== undefined">
                          <div v-if="list.orderedOptions?.length > 0">
                              <div style=" padding-bottom: 0px" v-for="ordered in list.orderedOptions"
                                  :key="ordered.objectId" class="p-0">
                                  <small>
                                      • {{ ordered.optionItemName }}
                                  </small>
                              </div>
                          </div>
                      </div> -->
                    <div v-if="list.orderedOptions !== undefined && list.orderedOptions?.length > 0"">
                        <div v-for="optionGroup in groupOptionItemsByGroup(list.orderedOptions)"
                      :key="optionGroup.objectId" class="pb-2">
                      <h6 style="color: gray;line-height: 100%;">{{ getCartOptionGroupName(optionGroup) }}</h6>
                      <h6 style="line-height: 100%;" class="pl-2" v-for="item in optionGroup.items">
                        • {{ getCartOptionItemName(item) }}<br>
                      </h6>
                    </div>
                  </div>

                  <div v-if="list.note != ''">
                    <small class="text-description">
                      {{ $t('note') }} :
                      <span style="color: #dd9447;">
                        " {{ list.note }} "
                      </span>

                    </small>
                  </div>
                </div>
                <small @click="showModal = true" data-toggle="modal" :data-target="'#listModal-' + list.id">
                  <!-- <small @click="deleteAllFromCartList(list)"> -->
                  <!-- Modal -->
                  <div v-if="showModal == true" class="modal fade" :id="'listModal-' + list.id">
                    <div class="modal-dialog" role="document">
                      <div style="background-color: unset;color: #3c4b64;" class="modal-content">
                        <div class="small-modal">
                          <div class=" d-flex text-dark align-items-center justify-content-center flex-column">
                            <i class="fi fi-rr-trash mt-4" style="font-size: 50px;"></i>
                            <h4 class="  text-center">{{ $t('removeSelected') }}</h4>
                          </div>
                          <div class="modal-footer  d-flex align-items-center justify-content-center">
                            <button @click="showModal = false" type="button" style="width: 45%;border-radius: 20px;"
                              class="btn btn-secondary h5" data-dismiss="modal">{{ $t('cancel') }}</button>
                            <button style="width: 45%;border-radius: 20px;" type="button" class="btn btn-danger h5"
                              @click="deleteAllFromCartList(list)" data-dismiss="modal">{{ $t('confirm') }}</button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <strong style="color: #c73e3e; font-size: 18px">
                    x
                  </strong>
                </small>
    </div>

    <table style="width: 100%" aria-describedby="" class="mt-1">
      <tr>
        <td style="width: 70%" valign="bottom">
          <!-- <h6 class="mb-0">฿{{ summary(list.totalAmount) }}</h6> -->
          <h6 class="mb-0 text-grey">฿{{ summary(list.totalAmount || list.productSKU.SKUPrice) }}
          </h6>
        </td>
        <td>

          <button v-if="list.quantity == 1"
            class="btn btn-outline-light text-color-theme btn-block btn-md add-qty-small" @click="showModal = true"
            style="border-radius: 50%;aspect-ratio: 1/1; border: 1px solid #b7b7b7;width: 45px;font-size: 20px;"
            data-toggle="modal" :data-target="'#listModal-' + list.id">
            <strong>-</strong>
          </button>
          <button v-if="list.quantity > 1" class="btn btn-outline-light text-color-theme btn-block btn-md add-qty-small"
            style=" border-radius: 50%; aspect-ratio: 1/1; border: 1px solid #b7b7b7; width: 45px;font-size: 20px;"
            @click="removeFromCart(list)">
            <strong>-</strong>
          </button>
        </td>
        <td style="width: 50%">
          <input readonly class="form-control form-control-md text-center font-weight-bold input-small"
            style="border: none; font-size: 20px;background-color: #ffffff;" v-model.number="list.quantity"
            pattern="[0-9]*" inputmode="numeric" type="number" min="0" />
        </td>
        <td>
          <button class="btn text-color-theme btn-outline-light  btn-block btn-md add-qty-small"
            style="border-radius: 50%;  aspect-ratio: 1/1; border: 1px solid #b7b7b7; width: 45px;font-size: 20px; "
            @click="addToCart(list)">
            <strong>+</strong>
          </button>
        </td>
      </tr>
    </table>
    </td>
    </tr>
    </table>
    </li>
    </ul>

    <div class="modal fade" id="price-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background-color: unset;">
          <div class="small-modal" style="background-color: white;">
            <div class="p-2 pt-3 text-center">
              <i style="color: var(--bg-color-theme);font-size: 40px;" class="fi fi-rr-info"></i>
              <h5 class="text-bold">{{ $t('vatNotInclude') }}</h5>
              <span class="text-description">{{ $t('checkGramdTotalIn') }}<br> "{{ $t('checkOut')
                }}"</span>
              <div class="mt-2 mb-2">
                <CButton block data-dismiss="modal" class="btn-color-theme ">{{
                  $t('accept') }}</CButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer v-if="OrderType !== 'delivery'" class="fixed-bottom"
      style="padding: 20px; background-color: #ffffff; box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.05); ">
      <div class="text-description text-center mb-3" style="font-size: large;">{{
        $t('checkOrderBeforeConfirm')
        }}<br>{{
          $t('checkOrderBeforeConfirm2') }}
      </div>
      <div class="row text-dark  pl-2 pr-2">
        <div class="col">
          <h5>{{ cartTotal }} {{ $t('item') }}</h5>
        </div>
        <div v-if="!shop.isVATIncluded" data-toggle="modal" data-target="#price-modal" class="col">
          <h5 class="font-weight-bold text-right">฿{{ totalCost }} <i style="color: var(--bg-color-theme);"
              class="fi fi-rr-info"></i></h5>
        </div>
        <div v-else class="col">
          <h5 class="font-weight-bold text-right">฿{{ totalCost }}</h5>
        </div>
      </div>
      <div v-if="errorMessage" class="error-box fade-in">
        <div class="error-row">
          <div class="error-icon">
            <i class="fi fi-rr-time-oclock"></i>
          </div>
          <div class="error-text">
            <div class="error-title">{{ errorMessage }}</div>
            <div v-if="kitchenMeta" class="meta-line">
              <span class="meta-label">{{$t('openHours')}}:</span>
              <span class="meta-time">
                {{ kitchenMeta.openTimeLocal || '-' }} - {{ kitchenMeta.closeTimeLocal || '-' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <CButton class="btn-selecteditem confirm-btn" size="lg" block @click="onConfirmOrder">
        {{ $t('confirmOrder') }}
      </CButton>
    </footer>
  </div>


  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util/util'
import order from '@/util/order'
import '@/util/menu.css'
import { CButton } from '@coreui/vue'
import pos from '@/services/pos'

export default {
  components: {
    CButton
  },
  data() {
    return {
      cartLists: [],
      cartTotal: 0,
      showModal: false,
      orderAble: false,
      errorMessage: '',
      qrType: localStorage.getItem('qrType') || 'DYNAMIC',
      kitchenMeta: null,
    }
  },
  computed: {
    ...mapGetters(['shopLineOA']),
    OrderType() {
      let type = window.location.pathname;
      if (type === '/dine-in/selecteditem') {
        return 'qr';
      } else {
        return 'delivery';
      }
    },
    uid() {
      return `${localStorage.getItem('uid')}`
    },
    shopObjectId() {
      return `${localStorage.getItem('shopObjectId')}`
    },
    shop() {
      return this.shopLineOA.find(
        (detail) => detail.objectId === this.shopObjectId
      )
    },
    shopName() {
      if (this.shop) {
        return this.shop.shopName
      } else {
        return ''
      }
    },
    logo() {
      if (this.shop) {
        return this.shop.remoteImagePath
      } else {
        return ''
      }
    },
    totalCost() {
      let total = this.cartLists.reduce((accum, product) => {
        return accum + product.totalAmount
      }, 0)

      return util.convertCurrency(total)
    },
    tableName() {
      let table = JSON.parse(localStorage.getItem('table'))
      return table.name
    },
    noImg() {
      return process.env.VUE_APP_NOIMAGE
    },
    imageSize() {
      if (this.OrderType == 'qr') {
        return 'big-img'
      } else {
        return 'small-img'
      }
    },
  },
  created() {
    this.getCartList()
    this.getCartTotal()
    window.pageYOffset = 0
  },
  methods: {
    ...util,
    getCartPLUName(list) {
      const locale = this.$i18n.locale
      const translation = list.nameTranslation || list.productPLU?.nameTranslation
      if (translation && translation[locale]) {
        return translation[locale]
      }
      try {
        const config = JSON.parse(localStorage.getItem('languageConfig'))
        if (config && config.fallbackType === 'translation' && config.fallbackLanguage) {
          if (translation && translation[config.fallbackLanguage]) {
            return translation[config.fallbackLanguage]
          }
        }
      } catch (e) {
        // ignore
      }
      return list.productPLU?.name || ''
    },
    getCartOptionGroupName(optionGroup) {
      const locale = this.$i18n.locale
      const translation = optionGroup?.nameTranslation
      if (translation && translation[locale]) {
        return translation[locale]
      }
      try {
        const config = JSON.parse(localStorage.getItem('languageConfig'))
        if (config && config.fallbackType === 'translation' && config.fallbackLanguage) {
          if (translation && translation[config.fallbackLanguage]) {
            return translation[config.fallbackLanguage]
          }
        }
      } catch (e) {
        // ignore
      }
      return optionGroup?.name || ''
    },
    getCartOptionItemName(item) {
      const locale = this.$i18n.locale
      const translation = item?.nameTranslation
      if (translation && translation[locale]) {
        return translation[locale]
      }
      try {
        const config = JSON.parse(localStorage.getItem('languageConfig'))
        if (config && config.fallbackType === 'translation' && config.fallbackLanguage) {
          if (translation && translation[config.fallbackLanguage]) {
            return translation[config.fallbackLanguage]
          }
        }
      } catch (e) {
        // ignore
      }
      return item?.name || ''
    },
    formatKitchenWindow(meta) {
      if (!meta) return ''
      // ถ้า closed=true แสดงว่า "ตั้งค่าไว้ว่า 'ปิดทั้งวัน' " แต่เรายังแสดงช่วงเวลาที่ตั้งค่าได้
      const tz = meta.timezone || 'Asia/Bangkok'
      const open = meta.openTimeLocal || '-'
      const close = meta.closeTimeLocal || '-'
      if (!meta.openTimeLocal && !meta.closeTimeLocal) {
        return ` ไม่มีช่วงเวลาทำการที่ตั้งค่าไว้`
      }
      if (meta.closed) {
        return ` วันนี้ปิดทั้งวัน (${open} - ${close})`
      }
      return `เปิด: ${open} - ${close}`
    },
    async onConfirmOrder() {
      this.errorMessage = ''
      this.kitchenMeta = null
      const canOrder = await this.verifyGate()
      if (!canOrder) {
        return
      }
      this.$router.push('/dine-in/pending')
    },
    async verifyGate() {
      // เลือก API ตาม qrType
      if (this.qrType === 'STATIC') {
        // เช็คครบ (เวลา/โต๊ะ/PIN)
        return await this.verifyOrderAble()
      } else {
        // เช็คเฉพาะเวลาครัวเปิด/ปิด
        return await this.verifyKitchenOnly()
      }
    },

    async verifyKitchenOnly() {
      try {
        const shopObjectId = `${localStorage.getItem('shopObjectId')}`
        const res = await pos({
          method: 'get',
          url: '/api/v3.0/shop/order/able/kitchen',
          headers: { shopObjectId },
        })

        const success = res?.data?.data?.success === true
        // เก็บ meta ทั้งสองกรณี (สำคัญ)
        this.kitchenMeta = res?.data?.data?.meta || res?.data?.error?.meta || null

        if (success) return true

        // ไม่ผ่าน → ตั้งข้อความ
        this.errorMessage = res?.data?.error?.message || 'Kitchen is closed at this time.'
        return false
      } catch (e) {
        console.error(e)
        this.kitchenMeta = null
        this.errorMessage = 'Cannot verify kitchen status.'
        return false
      }
    },
    async getCartList() {
      if (this.OrderType == 'qr') {
        this.cartLists = JSON.parse(sessionStorage.getItem('cart')) || []
      }
      else if (this.OrderType == 'delivery') {
        try {

          if (localStorage.getItem('token')) {
            const uid = localStorage.getItem('uid')
            const profile = JSON.parse(localStorage.getItem('profile'))
            const res = await pos({
              url: `/api/v1.3/${uid}/profile/cart?profileObjectId=${profile.objectId}&shopObjectId=${this.shopObjectId}&limit=100`,
              method: 'get',

            })
            if (res.data.error.code == 0) {
              this.cartLists = res.data.data
              this.$emit('item-changed')
              this.getCartTotal()

            } else if (res.data.error.code == 402) {
              this.renewToken()
            } else if (res.data.error.code == 4000) {
              this.logOut()
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    async renewToken() {
      try {
        if (localStorage.getItem('refreshToken')) {
          const refreshToken = localStorage.getItem('refreshToken')

          let res = {}
          res = await pos({
            url: `/auth/v1.0/renewtoken/otp`,
            method: 'post',
            data: {
              "refreshToken": refreshToken
            }
          });
          if (res.data?.error?.code == 0) {
            localStorage.setItem('token', res.data?.data?.token)
            window.location.reload()
          } else {
            this.logOut()
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    logOut() {
      const uid = localStorage.getItem('uid')
      const shopObjectId = localStorage.getItem('shopObjectId')
      sessionStorage.clear()
      localStorage.clear()
      localStorage.setItem('uid', uid)
      localStorage.setItem('shopObjectId', shopObjectId)
      this.$router.push('/delivery/home')
    },
    setErrorImg(event, image) {
      if (event.target.src == image) {
        event.target.src = this.noImg
      } else {
        event.target.src = image
      }
    },
    trackButtonClick(buttonLabel) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'click', {
          event_label: buttonLabel,
        });
      } else {
        console.error('gtag is not defined.');
      }
    },
    convertCurrency(num) {
      if (typeof num == 'number') {
        return '(+' + util.convertCurrency(Number(num)) + ')'
      } else {
        return ''
      }
    },
    getCartTotal() {
      let total = this.cartLists.reduce((accum, product) => {
        return accum + product.quantity
      }, 0)

      this.cartTotal = total
    },
    getImgColor(indexColor) {
      return util.generateColor(indexColor)
    },
    goback() {
      window.history.back()
    },
    summary(amount) {
      return util.convertCurrency(amount)
    },
    async addToCart(item) {
      if (this.OrderType == "delivery") {
        try {
          let product = order.updateAmountDelivery(item, 1)
          if (localStorage.getItem('token')) {
            const uid = localStorage.getItem('uid')
            const res = await pos({
              url: `/api/v1.3/${uid}/profile/cart/updateitem`,
              method: 'patch',
              data: product,
            })
            if (res.data.error.code == 0) {
              this.$emit('item-changed')
            } else if (res.data.error.code == 402) {
              this.renewToken()
            } else if (res.data.error.code == 4000) {
              this.logOut()
            }
          }
        } catch (error) {
          console.error(error);
        }
      } else if (this.OrderType == "qr") {
        this.trackButtonClick('SelectedItem/AddQTY')
        const locationInCart = this.cartLists.findIndex((p) => {
          return p.id === item.id
        })

        this.cartLists[locationInCart].quantity++

        let amount = order.updateAmount(
          this.cartLists[locationInCart],
          this.cartLists[locationInCart].quantity
        )

        this.cartLists[locationInCart].price = amount.price
        this.cartLists[locationInCart].netAmount = amount.amount
        this.cartLists[locationInCart].totalAmount = amount.amount
        this.cartLists[locationInCart].quantitySKU = amount.quantitySKU


        sessionStorage.setItem('cart', JSON.stringify(this.cartLists))
        this.getCartTotal()
      }
    },
    async removeFromCart(item) {
      this.trackButtonClick('SelectedItem/RemoveQTY')
      this.showModal = false
      const locationInCart = this.cartLists.findIndex((p) => {
        return p.id === item.id
      })

      if (this.OrderType == "delivery") {
        try {
          let product = order.updateAmountDelivery(item, -1)
          if (localStorage.getItem('token')) {
            const uid = localStorage.getItem('uid')
            const res = await pos({
              url: `/api/v1.3/${uid}/profile/cart/updateitem`,
              method: 'patch',
              data: product,
            })
            if (res.data.error.code == 0) {
              this.$emit('item-changed')
            } else if (res.data.error.code == 402) {
              this.renewToken()
            } else if (res.data.error.code == 4000) {
              this.logOut()
            }
          }
        } catch (error) {
          console.error(error);
        }
      } else if (this.OrderType == "qr") {
        if (this.cartLists[locationInCart].quantity <= 1) {
          this.cartLists.splice(locationInCart, 1)
        } else {
          this.cartLists[locationInCart].quantity--
          let amount = order.updateAmount(
            this.cartLists[locationInCart],
            this.cartLists[locationInCart].quantity
          )
          this.cartLists[locationInCart].price = amount.price
          this.cartLists[locationInCart].netAmount = amount.amount
          this.cartLists[locationInCart].totalAmount = amount.amount
          this.cartLists[locationInCart].quantitySKU = amount.quantitySKU
        }
        sessionStorage.setItem('cart', JSON.stringify(this.cartLists))
        this.getCartTotal()
      }
    },
    async setSelect(product) {
      try {
        product.isSelected = !product.isSelected
        if (localStorage.getItem('token')) {
          const uid = localStorage.getItem('uid')
          const res = await pos({
            url: `/api/v1.3/${uid}/profile/cart/updateitem`,
            method: 'patch',
            data: product,
          })
          if (res.data.error.code == 0) {
            this.$emit('item-changed')
          } else if (res.data.error.code == 402) {
            this.renewToken()
          } else if (res.data.error.code == 4000) {
            this.logOut()
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async deleteAllFromCartList(product) {
      this.showModal = false
      const locationInCart = this.cartLists.findIndex((p) => {
        return p.id === product.id
      })
      if (this.OrderType == "delivery") {
        try {
          product.quantity = 0
          if (localStorage.getItem('token')) {
            const uid = localStorage.getItem('uid')
            const res = await pos({
              url: `/api/v1.3/${uid}/profile/cart/removeitem`,
              method: 'delete',
              data: product,
            })
            if (res.data.error.code == 0) {
              this.$emit('item-changed')
              this.getCartList()
            } else if (res.data.error.code == 4000) {
              alert('Token Expired')
              // this.logOut()
            }
          }
        } catch (error) {
          console.error(error);
        }
      } else if (this.OrderType == "qr") {
        this.cartLists.splice(locationInCart, 1)
        sessionStorage.setItem('cart', JSON.stringify(this.cartLists))
        this.getCartTotal()
      }
    },
    groupOptionItemsByGroup(orderedOptions) {
      return util.groupOptionItemsByGroup(orderedOptions)
    },
    async verifyOrderAble() {
      try {
        const shopObjectId = `${localStorage.getItem('shopObjectId')}`
        const response = await pos({
          method: 'get',
          url: '/api/v3.0/shop/order/able',
          headers: { shopObjectId }
        })

        // ✅ success = true
        if (response.data?.data?.success === true) {
          return true
        } else {
          // ✅ fail กรณีครัวปิด
          this.errorMessage = response.data?.error?.message || 'Shop is not accepting orders.'
          return false
        }
      } catch (error) {
        console.error(error)
        this.errorMessage = 'Cannot verify order status.'
        return false
      }
    },
    buildHomeQuery() {
      // ดึงค่าจาก route ก่อน แล้วค่อย fallback เป็น localStorage
      const isDynamic = (localStorage.getItem('qrType') || '').toUpperCase() === 'DYNAMIC'
      const q = this.$route?.query || {}
      return {
        uid: q.uid || localStorage.getItem('uid') || '',
        shopObjectId: q.shopObjectId || localStorage.getItem('shopObjectId') || '',
        tableObjectId: q.tableObjectId || localStorage.getItem('tableObjectId') || '',
        pax: q.pax || localStorage.getItem('pax') || '',
        ...(isDynamic
          ? { otp: this.$route.params?.otp || localStorage.getItem('otp') || '' }
          : {}
        )
      }
    },

  },
}
</script>

<style scoped>
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.modal {
  align-items: center;
  justify-content: center;
  /* height: 35%; */
  width: 80%;
  border-radius: 3%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1070;
}

.modal-backdrop.show {
  opacity: 0.5;
  z-index: 1000;
}

.modal .modal-body {
  overflow-y: hidden;
}

@media screen and (max-width: 370px) {
  .add-qty-small {
    width: 30px !important;
    height: 30px !important;
    font-size: 10px !important;
    text-align: center;
  }

  .input-small {
    font-size: 10px !important;
  }


}

img.image-inbox {
  position: relative;
  object-fit: cover;
}

.list-group-item:last-child {
  border: none;
}

.big-img {
  width: 90px;
  height: 90px
}

.small-img {
  width: 65px;
  height: 65px
}

.error-box {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 14px;
  padding: 14px 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 3px rgba(220, 38, 38, 0.08);
}

.error-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.error-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.error-icon i {
  font-size: 16px;
  color: #dc2626;
}

.error-text {
  flex: 1;
  min-width: 0;
}

.error-title {
  color: #dc2626;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
}

.meta-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  /* padding: 4px 10px; */
  background: #fff7ed;
  border-radius: 8px;
  width: fit-content;
}

.meta-line i {
  font-size: 12px;
  color: #d97706;
}

.meta-line span {
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
}

.confirm-btn {
  font-size: 20px !important;
  font-weight: bold;
  border-radius: 12px;
}

.fade-in {
  animation: fadeIn 0.25s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
